export default "__VITE_ASSET__741440d2__"